// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main[data-v-425c7daf]{background-color:#fff;padding-top:4.5rem}", "",{"version":3,"sources":["webpack://./resources/client/components/layout/LayoutComponent.scss"],"names":[],"mappings":"AAAA,uBAEE,qBAAA,CADA,kBAEF","sourcesContent":[".main {\n  padding-top: 4.5rem;\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
